export const TechnicalViewActionType = Object.freeze({
  SET_IS_INITIAL_MOUNT: "Technical View:: Set Is Initial Mount",
  TOGGLE_ABOUT: "Technical View:: Toggling the About Drawer",
  TOGGLE_ABOUT_HIDDEN: "Central Arizona:: Toggling the About Drawer Being completly hidden",
  SET_CHART: "Technical View:: Set chart",
  SET_SCENARIO: "Technical View:: Set Scenario",
  SET_SCENARIO_SELECTED: 'Technical View:: Set Scenario Selected',
  SET_PREVIOUS_MAP_SELECTION: 'Technical View:: Set Previous Map Selection',
  SET_ALL_SCENARIOS: 'Technical View:: Set all Scenarios',
  RESET_SIDEBAR_ACCORDIONS: "Technical View:: Reset sidebar accordions chart",
  UPDATE_SIDEBAR_ACCORDIONS: "Technical View:: Update sidebar accordions chart",
  // COLORADO RIVER WATER ACCSESS
  SET_AREA_CHART_TAB: "Colorado River Water Access:: Set tab",
  // CENTRAL AZ WATER USES
  SET_CENTRAL_AZ_TAB: "Central AZ Water Uses:: Set tab",
  // POLYGON MAP
  SET_POLYGON_MAP_TAB: "Polygon Map:: Set tab",
  // IRRIGATION (AGRICULTURE) DISTRICTS
  SET_ALL_IRRIGATION_DISTRICTS:
    "Irrigation District Water User:: Get All Irrigation Districts",
  SET_SELECTED_IRRIGATION_DISTRICT:
    "Irrigation District Water User:: Selected Irrigation District",
  SET_DISTRICT_WATER: "Irrigation District Water User:: Set District Water Use",
  SET_DELIVERIES:
    "Irrigation District Water User:: Set District Water Deliveries",
  RESET_SELECTED_AGRICULTURE:
    "Irrigation District Water User:: Reset Selected Irrigation District",
  // INDUSTRY
  SET_INDUSTRY_METRICS: "Industry Water User:: Set Industry metrics",
  // CITIES
  SET_ALL_CITIES: "City Water User:: Get all Cities",
  SET_CITY_METRICS: "City Water User:: Set City Metrics",
  SET_SELECTED_CITY: "City Water User:: Selected City",
  RESET_SELECTED_CITY: "City Water User:: Reset Selected City",
  SET_CITY_WATER_SOURCES: "City Water User:: Set City Water Sources",
  SET_BIG_RIVER_POLICY: "Technical View:: Set big river policy",
  SET_CITY_METRICS_GAUGE: "City Water User:: Set City Metrics for Gauge Chart",
  SET_SELECTED_CITY_GAUGE: "City Water User:: Selected City for Gauge Chart",
  SET_CITY_POPULATION: "City Water User:: Set City Population",
  SET_IS_CITY: "City Water Use:: Set is City",
  RESET_SELECTED_CITY_GAUGE:
    "City Water User:: Reset Selected City for Gauge Chart",
  // CO RIVER USE VS ACCESS
  SET_ENTITY_ENTITLEMENTS: "Colorado River Access:: Set Entity Entitlements",
  SET_ENTITLEMENT_YEAR: "Colorado River Access:: Set Entitlement Year",
  SET_SLIDER_ENTITLEMENT_YEAR: "Colorado River Access:: Set Slider Entitlement Year",
  SET_ENTITLEMENTS_BY_YEAR: "Colorado River Access:: Set Entitlements By Year",
  SET_ENTITLEMENTS_BY_YEAR_RANGE:
    "Colorado River Access:: Set Entitlements By Year Range",
  SET_USER_LAST_SELECTED_MAP_STATE: "Colorado River Access:: Set Last Selected Map State Of The User",
  SET_ALL_CITY_METRICS: "Technical View:: Set All Cities Metrics",
  SET_ALL_CITY_WATER_USE: "Technical View:: Set All Cities Water Use",
  SET_ALL_TRIBES: "Tribe Water User:: Get all Tribes",
  SET_SELECTED_TRIBE: "Tribe Water User:: Selected Tribe",
  SET_TRIBE_METRICS: "Tribe Water User:: Set Tribe Metrics",
  SET_IS_TRIBE: "Technical View:: Set isTribe",
  SET_PRIORITY_ENTITLEMENTS: "Central Arizona:: Set Priority Pool Entitlements",
  SET_PER_PERSON_ENTITLEMENT_DIFFERENCE:
    "Central Arizona:: Set Entitlement Difference for Each Person (Honeycomb per capita)",
  SET_WESTERN_ARIZONA_ENTITIES: "Western Arizona:: Set Entities",
  SET_WESTERN_ARIZONA_ENTITLEMENTS: "Western Arizona:: Set Entitlements",
  SET_WESTERN_ARIZONA_SELECTED: "Western Arizona:: Set Western Arizona Entity",
  SET_WESTERN_ARIZONA_PRIORITY_ENTITLEMENTS: "Western Arizona:: Set Western Arizona Priority Entitlements",
  SET_WESTERN_ARIZONA_ENTITY_ENTITLEMENTS: "Western Arizona:: Set Western Arizona Entity Entitlements",
  SET_IS_WESTERN: "Western Arizona:: Set is Western",
  CHANGE_SLIDER_RANGE: "Technical View:: Change slider range",
  // MAP
  SET_MAP_ZOOM: "Technical View:: Set Map zoom",
  SET_ENTITY_HEADER: "SET_ENTITY_HEADER",
});

export const population = {
  Phoenix: 1579000,
  "Arizona Water Co. (Superstition System)": 60729,
  "Arizona Water Co. (Pinal)": 88019,
  "Arizona Water Co. (White Tank System)": 13836,
  Avondale: 83001,
  Buckeye: 15309,
  "Carefree Water Co.": 3587,
  "Cave Creek": 6815,
  Chandler: 247328,
  "EPCOR (Chaparral City)": 813,
  "Circle City Water Co.": 459,
  "Green Valley": 22085+8687,
  // # EPCOR - ANTHEM is Del Webb
  "Del Webb": 25302,
  "El Mirage": 39884,
  Eloy: 8859,
  "EPCOR (Agua Fria)": 80959,
  "EPCOR (Paradise Valley)": 12000,
  "EPCOR (Sun City)": 38016,
  "EPCOR (Sun City West)": 25362,
  "EPCOR (San Tan)": 87435,
  Florence: 15900,
  "Flowing Wells Irrigation District": 16000,
  Gilbert: 247600,
  Glendale: 234766,
  Goodyear: 50001,
  // "Green Valley Domestic Water Improvement District": 8687,
  Marana: 10773,
  Mesa: 466000,
  "Metropolitan Domestic Water Improvement District": 46977,
  "Oro Valley": 40744,
  Peoria: 135975,
  "Apache Junction CFD": 13657,
  "Queen Creek": 86969,
  "Rio Verde Utilities": 4751,
  Scottsdale: 249950,
  "Spanish Trail Water Co.": 2055,
  Surprise: 31649,
  Tempe: 165000,
  "Tonto Hills Domestic Water Improvement District": 350,
  Tucson: 675686,
  "Vail Water Co.": 13000,
  Tonopah: 762,
};

export const DONUT_CHART_CONTENTS = {
  No_Data: 'Results coming soon',
  Chart_Content: 'Total Water Use & Deliveries',
}

export const YEAR_LIST = Array.from({ length: 2060 - 2024 + 1 }, (_, i) => 2024 + i);